import { useQuery } from '@tanstack/react-query';
import { clientGetEstateStatusHouseholdSettings, useGraphqlClient } from '../../graphql';
import { estateStatusKeys } from '../queryKeys';

export function useEstateStatusHouseholdSettings(householdID: string | undefined | null) {
  const gqlClient = useGraphqlClient();

  const query = useQuery({
    enabled: !!householdID,
    queryKey: estateStatusKeys.householdSettings(householdID),
    queryFn: () => {
      if (!householdID) {
        throw new Error('Household ID is required to load Estate Status.');
      }

      return clientGetEstateStatusHouseholdSettings(gqlClient, { householdID });
    },
  });

  return { estateStatusHouseholdSettings: query.data, estateStatusHouseholdSettingsQuery: query };
}
